import { useEffect, useState } from 'react';
import type { UserType } from '../redux/config/users-api';
import { useGetUserQuery } from '../redux/config/users-api';

export function useDashboardUser(): UserType | undefined {
  const [user, setUser] = useState<UserType>();
  const { data: userInfo } = useGetUserQuery();

  useEffect(() => {
    setUser(userInfo);
  }, [userInfo]);

  return user;
}
